
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.267 4.675c-.466-.826-.699-1.238-.562-1.614.137-.375.577-.53 1.457-.843l.75-.265c.538-.19.808-.286 1.087-.286.28 0 .55.095 1.088.286l.75.265c.88.312 1.32.468 1.457.843.137.376-.096.788-.562 1.614l-.43.761c-.221.391-.331.587-.524.74-.194.153-.372.204-.73.306-.343.099-.734.185-1.049.185-.314 0-.705-.086-1.048-.185-.358-.102-.537-.153-.73-.306-.193-.153-.303-.349-.524-.74l-.43-.761zM8.399 6.667L7.017 12.62c-.3 1.29-.45 1.936-.279 2.543l.01.036c.18.604.652 1.065 1.594 1.987.777.761 1.166 1.142 1.644 1.147h.027c.478-.005.866-.386 1.644-1.146.942-.923 1.413-1.384 1.593-1.988l.01-.036c.172-.607.022-1.252-.278-2.543L11.6 6.667","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    